export const getB2CRedirectSignInUrl = () => {
    //non- production 
    return "https://stateofneb2cdev.b2clogin.com/stateofneb2cdev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_IDENTITY_MANAGEMENT_SIGNUP_SIGNIN&client_id=adeb9e71-23dc-433a-b84f-6dcc963aa6cb&nonce=defaultNonce&redirect_uri=" +

        //local
        "https://sys-ciaam-dhhs.nebraska.gov/external-home" +

        "/&scope=openid adeb9e71-23dc-433a-b84f-6dcc963aa6cb&response_type=code&isMFA=true";
}

export const getB2CRedirectLogoutUrl = (): string => {
    return "https://stateofneb2cdev.b2clogin.com/stateofneb2cdev.onmicrosoft.com/oauth2/v2.0/logout?p=B2C_1A_DHHS_INTEROP_PIPELINE_SIGNUP_SIGNIN&post_logout_redirect_uri=" +

        //local
        "https://sys-ciaam-dhhs.nebraska.gov/"
}

export const getIdMeBaseApiUrl = () => {
    return "https://sys-ciaam-dhhs.nebraska.gov/api";
}